import React, { useEffect } from 'react'
import AppBar from '@mui/material/AppBar'
import Container from '@mui/material/Container'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Menu from '@mui/material/Menu'
import MenuIcon from '@mui/icons-material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Box from '@mui/material/Box'
import Novir from '../../assets/images/novir.png'
import { Link } from 'react-router-dom'
import useSignOut from '../../hooks/authentication/useSignOut'
import PropTypes from 'prop-types'

const Header = ({ user, gotUser }) => {
  const [anchorElNav, setAnchorElNav] = React.useState(null)

  const { data, isSuccess, refetch: signOut } = useSignOut()

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget)
  }
  
  const handleCloseNavMenu = () => {
    setAnchorElNav(null)
  }

  const handleLogout = () => {
    signOut()
  }

  useEffect(() => {
    if (isSuccess) {
      window.location = data
    }
  }, [isSuccess])
    
  return (
    <AppBar
      id='header'
      position='sticky' 
      elevation={0}
      sx={{
        height: { md: '95px' },
      }}
    >
      <Container maxWidth='xl'>
        <Toolbar disableGutters>
          <Box
            sx={{ 
              display: { xs: 'none', md: 'flex' },
              flexDirection: 'column',
              marginTop: '15px',
              flexGrow: gotUser ? .4 : .5
            }}
          >
            {
              gotUser && (
                <>
                  <Typography
                    component='div'
                    sx={{
                      color: '#27417A',
                      display: 'flex'
                    }}
                  >
                Hello, &nbsp;
                    <Typography
                      component={Link}
                      noWrap
                      to="/"
                      sx={{
                        fontWeight: 'bold'
                      }}
                    >
                      {user.displayName}
                    </Typography>
                &nbsp;|&nbsp;
                    <Typography
                      component='a'
                      noWrap
                      href="#"
                      onClick={handleLogout}
                    >
                 Logout
                    </Typography>
                  </Typography>
                  <Typography
                    sx={{
                      color: '#3DA267'
                    }}
                  >
                Welcome to the Intranet 1.0!
                  </Typography>
                </>
              )
            }
            
          </Box>
          <Box
            sx={{
              marginTop: '15px',
              display: { xs: 'none', md: 'flex' }
            }}
          >
            <Box
              component={Link}
              to="/"
              sx={{
                color: '#27417A',
                textDecoration: 'none',
                textAlign: 'center',
                display: 'flex'
              }}
            >
              <Box
                component='img'
                src={Novir}
                alt='Novir Logo'
                sx={{
                  fontWeight: 'bold',
                  mr: 2
                }}
              />
              <Typography
                variant='h3'
                sx={{
                  fontWeight: 'bold',
                  mt: 2
                }}
              >
                &quot;INTRANET&quot;
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: '15px',
              display: { xs: 'flex', md: 'none' },
              flexDirection: 'column',
              flexGrow: 1,
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {
              gotUser && (
                <Typography
                  component='div'
                  sx={{
                    color: '#27417A',
                    display: 'flex'
                  }}
                >
                Hello, &nbsp;
                  <Typography
                    component={Link}
                    noWrap
                    to="/"
                    sx={{
                      fontWeight: 'bold'
                    }}
                  >
                    {user.displayName}
                  </Typography>
                &nbsp;|&nbsp;
                  <Typography
                    component={'a'}
                    noWrap
                    href="#"
                    onClick={handleLogout}
                  >
                 Logout
                  </Typography>
                </Typography>
              )
            }
            
            <Box
              component={Link}
              to="/"
              sx={{
                color: '#27417A',
                textDecoration: 'none',
                textAlign: 'center'
              }}
            >
              <Box
                component='img'
                src={Novir}
                alt='Novir Logo'
                sx={{
                  fontWeight: 'bold'
                }}
              />
              <Typography
                variant='h5'
                sx={{
                  fontWeight: 'bold'
                }}
              >
                &quot;INTRANET&quot;
              </Typography>
            </Box>
            {
              gotUser && (
                <Typography
                  sx={{
                    color: '#3DA267'
                  }}
                >
                Welcome to the Intranet 1.0!
                </Typography>
              )
            }
          </Box>
          {
            gotUser && (
              <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                <IconButton
                  size="large"
                  aria-label="hamburger menu"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleOpenNavMenu}
                  color="inherit"
                  sx={{ color: '#a7a7a7' }}
                >
                  <MenuIcon fontSize='large' />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorElNav}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={Boolean(anchorElNav)}
                  onClose={handleCloseNavMenu}
                  sx={{
                    display: { xs: 'block', md: 'none' },
                  }}
                >
                  <MenuItem onClick={handleCloseNavMenu}>
                    <Typography textAlign="center">Something goes here</Typography>
                  </MenuItem>
                  <MenuItem onClick={handleCloseNavMenu}>
                    <Typography textAlign="center">Something goes here</Typography>
                  </MenuItem>
                </Menu>
              </Box>
            )
          }
          
        </Toolbar>
      </Container>
    </AppBar>
  )
}

Header.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    givenName: PropTypes.string,
    surname: PropTypes.string,
    displayName: PropTypes.string
  }),
  gotUser: PropTypes.bool
}

export default Header